// The reference date (Stichtag) is meaningful when at least one atDate column is selected.
export const REFERENCE_DATE_COLUMN_IDS = [
	'institutionAtDate',
	'schoolNumberAtDate',
	'socialSecurityStatusAtDate',
	'disabilityTypeAtDate',
	'disabilityProofAtDate',
	'gdbAtDate',
] as const;

export function isReferenceDateAvailable(selectedColumnIds: readonly string[]): boolean {
	const selected = new Set(selectedColumnIds);
	return REFERENCE_DATE_COLUMN_IDS.some((id) => selected.has(id));
}

// The backend only accepts the fixed offset +01:00, so the calendar day is sent with that offset
// regardless of the browser zone or summer time. The input is not mutated.
export function formatReferenceDate(date: Date): string {
	const pad = (value: number) => String(value).padStart(2, '0');
	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T23:59:59+01:00`;
}

function startOfToday(): Date {
	const now = new Date();
	return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

// Single gate for the request: a value is only sent when the UI would allow it.
export function resolveReferenceDateParam(
	referenceDate: Date | null,
	selectedColumnIds: readonly string[],
): string | undefined {
	if (!referenceDate || !isReferenceDateAvailable(selectedColumnIds)) return undefined;
	const day = new Date(referenceDate.getFullYear(), referenceDate.getMonth(), referenceDate.getDate());
	if (day > startOfToday()) return undefined;
	return formatReferenceDate(day);
}
